const EMBEDDED_BROWSER_MATCHERS = [
  { name: "Messenger", pattern: /(Messenger|FBAN|FBAV|FB_IAB)/i },
  { name: "Instagram", pattern: /Instagram/i },
  { name: "TikTok", pattern: /TikTok/i },
  { name: "Line", pattern: /Line\//i },
  { name: "WeChat", pattern: /MicroMessenger/i },
  { name: "Snapchat", pattern: /Snapchat/i },
  { name: "X", pattern: /Twitter/i },
  { name: "LinkedIn", pattern: /LinkedInApp/i },
];

export function getEmbeddedBrowserName(userAgent) {
  const resolvedUserAgent =
    typeof userAgent === "string"
      ? userAgent
      : typeof navigator !== "undefined"
        ? navigator.userAgent || ""
        : "";

  if (!resolvedUserAgent) return null;

  const matchedBrowser = EMBEDDED_BROWSER_MATCHERS.find(({ pattern }) =>
    pattern.test(resolvedUserAgent)
  );

  if (matchedBrowser) {
    return matchedBrowser.name;
  }

  if (/\bwv\b/i.test(resolvedUserAgent) || /WebView/i.test(resolvedUserAgent)) {
    return "this in-app browser";
  }

  return null;
}

export function isEmbeddedBrowser(userAgent) {
  return Boolean(getEmbeddedBrowserName(userAgent));
}
